import React from 'react';

const CustomEventLeaderboardHoleColumn = ({ playerHole }) => {
    const hole = (playerHole === null || playerHole === undefined || playerHole === '') ? '-' : playerHole;
    return (
        <div className="custom-event-leaderboard__cell custom-event-leaderboard__cell--hole">
            <div className="custom-event-leaderboard__label">
                HOLE
            </div>
            <div className=" score-cell score-cell--default score-cell--has-border">
                {hole}
            </div>
        </div>
    );
};

export default CustomEventLeaderboardHoleColumn;
